export const RAMO_ENUM = {
    VEHICULOS: 'VEHICULOS PERSONALES',
    PYMES: 'PYMES'
};
